import React from 'react';
import Section from '../layout/Section';

const RoadmapSection: React.FC = () => {
  return (
    <Section
      kicker="Work in progress — v0.2.1 alpha"
      title="Functional, but not yet production-ready."
      body="ZFS unlock works end-to-end. LUKS support is scaffolded. The next milestone is a clean install experience from the .deb with no hand-holding required."
    >
      <div className="lc-grid lc-grid--2">
        <article className="lc-card">
          <h3 className="lc-card-title">v0.3.0 goal — clean install from .deb</h3>
          <p className="lc-card-body">
            Target: a fresh Ubuntu 24.04 host, one <code>apt install lockchain</code>, and a
            working ZFS unlock at next boot — with no reading of source required. If you still need
            the README to get it running, v0.3.0 isn&apos;t done yet.
          </p>
        </article>

        <article className="lc-card">
          <h3 className="lc-card-title">LUKS provider — real implementation</h3>
          <p className="lc-card-body">
            The <code>lockchain-luks</code> crate is currently scaffolding only. LUKS targets,{' '}
            <code>crypttab</code> integration, and initrd hooks are the next provider milestone
            after the ZFS install experience is solid.
          </p>
        </article>

        <article className="lc-card">
          <h3 className="lc-card-title">UI &amp; operator experience</h3>
          <p className="lc-card-body">
            A keyboard-first control deck (<code>lockchain-ui</code>) is being wired into the same
            workflow engine, so operators can see unlock state and policy outcomes across both
            encryption providers without living in logs.
          </p>
        </article>

        <article className="lc-card">
          <h3 className="lc-card-title">Docs &amp; runbooks</h3>
          <p className="lc-card-body">
            Troubleshooting guides for degraded pools, broken hardware and misconfigured datasets
            are on the list — covering both LUKS and ZFS targets, day-two operations, and a
            security operations guide tied to the existing threat model.
          </p>
        </article>

        <article className="lc-card">
          <h3 className="lc-card-title">Threat model &amp; hardening</h3>
          <p className="lc-card-body">
            A formal threat model and attack surface document will spell out assumptions, non-goals
            and recommended hardening measures for both unlock paths, so teams can map LockChain
            onto their own controls and be fully informed before adopting it.
          </p>
        </article>

        <article className="lc-card">
          <h3 className="lc-card-title">Edge cases &amp; telemetry</h3>
          <p className="lc-card-body">
            Additional test suites for unusual ZFS layouts and LUKS edge cases, optional telemetry
            with pluggable sinks, and performance profiling helpers are all under consideration as
            the user base grows.
          </p>
        </article>
      </div>
    </Section>
  );
};

export default RoadmapSection;
